import React, { Component, Fragment } from 'react';
import FormInputText from '../_shared/forms/FormInputText';
import CreatableSelect from '../_shared/forms/FormCreatableSelect';
import SubmitButton from '../_shared/SubmitButton';
import ReactDOM from 'react-dom';
import { snakeCaseToTitle } from '../../utils/Helpers';
import UserService from '../../services/UserService';

class Coverage extends Component {
    constructor(props) {
        super(props);

        this.userService = new UserService();

        const { user } = this.props;

        const zone = {
            name: '',
            prefixes: [],
            errors: {},
        };

        let zones = user.coverage_area && user.coverage_area.length > 0 ? [...user.coverage_area] : [zone];
        //  Generate unique id for each zone to use in react-select
        zones.map((zone, index) => {
            return (zone.id = index + 1);
        });
        console.log(user);
        console.log(zones);
        let postcodes = this.props.postcodes;
        zones.forEach((zone) => {
            zone.prefixes.forEach((postcode) => {
                let postcodeOption = postcodes.findIndex((postcodeOption) => {
                    return postcodeOption.id === postcode.id;
                });

                if (postcodeOption !== -1) {
                    postcodes[postcodeOption] = { ...postcodes[postcodeOption], disabled: true };
                }
            });
        });

        this.state = {
            zones: zones,
            postcodes: postcodes,
            errors: {},
            zoneDeleteError: '',
            loading: false,
            showSuccessToast: false,
            showErrorToast: false,
        };
    }

    handleZoneInputChange = (e, i) => {
        this.resetErrors();
        const { name, value } = e.target;
        let zones = [...this.state.zones];

        zones[i] = {
            ...zones[i],
            [name]: value,
        };

        this.setState({ zones });
    };

    appendZone = (e) => {
        e.preventDefault();
        this.resetErrors();
        this.setState((prevState) => ({
            zones: [
                ...prevState.zones,
                {
                    //  Generate unique id for this zone by getting id of last zone element in 'prevState' and increment by 1
                    id: prevState.zones[prevState.zones.length - 1].id + 1,
                    name: '',
                    prefixes: [],
                    errors: {},
                },
            ],
        }));
    };

    handleMultiSelectChange = (value, i) => {
        let zones = [...this.state.zones];
        zones[i] = {
            ...zones[i],
            prefixes: value || [],
        };

        //disable selected postcode
        let postcodes = [...this.state.postcodes];
        if (typeof zones[i].prefixes[zones[i].prefixes.length - 1] !== 'undefined') {
            let postcodeIndex = postcodes.findIndex((postcode) => {
                return postcode.id === zones[i].prefixes[zones[i].prefixes.length - 1].id;
            });
            if (postcodeIndex !== -1) {
                postcodes[postcodeIndex] = { ...postcodes[postcodeIndex], disabled: true };
            }
        }

        this.setState({
            zones,
            postcodes,
        });
    };

    removeZone = (e, i) => {
        e.preventDefault();

        if (this.state.zones.length === 1) {
            return this.setState({
                zoneDeleteError: 'You need to add at least one coverage zone',
            });
        }

        window.swal
            .fire({
                title: `Delete this zone?`,
                text: `Are you sure you want to delete this coverage zone?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;
                this.setState((prevState) => ({
                    zones: prevState.zones.filter((zone) => prevState.zones.indexOf(zone) !== i),
                }));
            });
    };

    resetErrors = () => {
        let zones = [...this.state.zones];
        zones.map((zone) => (zone.errors = {}));

        this.setState({
            errors: {},
            zones: zones,
            zoneDeleteError: '',
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        this.setState({ loading: true });

        if (await this.validateForm()) {
            this.userService
                .storeCoverage(this.props.user.id, this.state)
                .then(
                    (res) => {
                        //  Stop spinner flag
                        this.setState({ loading: false });
                        toastr.success('Coverage successfully saved');
                    },
                    (err) => {
                        this.setState({
                            errors: err.response.data.errors,
                            loading: false,
                        });
                    }
                )
                .catch(() => {
                    this.setState({
                        loading: false,
                    });
                    toastr.error('There was a problem while submitting the form. Please try again');
                });
        } else {
            this.setState({
                loading: false,
            });
        }
    };

    validateForm = async () => {
        let valid = true;

        if (!(await this.validateZones())) valid = false;

        return valid;
    };

    validateZones = async () => {
        let valid = true;
        let zones = [...this.state.zones];
        zones.map((zone, index) => {
            if (zone.prefixes.length === 0) {
                zones[index].errors.prefixes = 'Postcodes field is required';
                valid = false;
            }

            if (zone.name === '') {
                zones[index].errors.name = 'Name field is required';
                valid = false;
            }
        });

        await this.setState({ zones });
        return valid;
    };

    render() {
        const { errors, zones, zoneDeleteError } = this.state;

        return (
            <Fragment>
                <form onSubmit={(e) => this.handleSubmit(e)} className="transform-text">
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <h6 className="py-2 pl-2 cw-bg-grey text-white">Coverage Zones</h6>
                            </div>
                        </div>
                        {this.state.zones.map((zone, i) => {
                            return (
                                <Fragment key={zone.id}>
                                    <div className="row">
                                        <div className="form-group col-md-4">
                                            <FormInputText
                                                label="Zone Name"
                                                name="name"
                                                type="text"
                                                classes={zone.errors.name ? 'form-control is-invalid' : 'form-control'}
                                                error={zone.errors.name}
                                                value={zone.name}
                                                handleChange={(e) => this.handleZoneInputChange(e, i)}
                                            />
                                            {zoneDeleteError && (
                                                <small className="text-danger">{zoneDeleteError}</small>
                                            )}
                                        </div>
                                        <div className="form-group col-md-4">
                                            <CreatableSelect
                                                isMulti
                                                label="covers postcodes"
                                                options={this.state.postcodes}
                                                handleMultiSelectChange={(e) => this.handleMultiSelectChange(e, i)}
                                                error={zone.errors.prefixes}
                                                classes={
                                                    zone.errors.prefixes ? 'form-control is-invalid' : 'form-control'
                                                }
                                                prefixes={zone.prefixes}
                                            />
                                        </div>
                                        <div className="form-group col-md-1 text-center">
                                            <label>&nbsp;</label>
                                            <div onClick={(e) => this.removeZone(e, i)}>
                                                <i className="nc-icon nc-simple-remove icon-bold text-danger pb-3"> </i>
                                            </div>
                                        </div>
                                    </div>
                                </Fragment>
                            );
                        })}
                        <div className="row">
                            <div className="col-12">
                                <button type="button" onClick={this.appendZone} className="btn btn-outline-cw-primary">
                                    <i className="fas fa-plus-square"> </i> Add new zone
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-3">
                        <div className="col-12">
                            <SubmitButton
                                buttonText={'Save coverage'}
                                loading={this.state.loading}
                                style={{ width: 230, marginTop: 50 }}
                            />
                        </div>
                    </div>
                </form>
            </Fragment>
        );
    }
}

if (document.getElementById('user-coverage')) {
    let element = document.getElementById('user-coverage');

    ReactDOM.render(
        <Coverage
            postcodes={JSON.parse(element.dataset.postcodes)}
            user={JSON.parse(element.dataset.user)}
            coverage={element.dataset.coverage}
        />,
        element
    );
}

export default Coverage;
